import { TrackingEvent, useAnalytics } from '@cinch-nx/shared-analytics'
import { ReactNode } from 'react'
import styles from '../shared-ui-footer.module.css'

export type SocialNetworkButtonProps = {
  icon: ReactNode
  link: string
  name: string
  trackingEvent?: TrackingEvent // TODO: SET AS REQUIRED WHEN SETTING THE TRACKING
}

export const SocialNetworkButton = ({
  icon,
  link,
  name,
  trackingEvent,
}: SocialNetworkButtonProps) => {
  const { trackEvent } = useAnalytics()

  const handleClick = () => {
    if (trackingEvent) {
      trackEvent(trackingEvent)
    }
  }

  return (
    <a
      href={link}
      className={styles.link}
      onClick={handleClick}
      rel="noopener noreferrer"
      target="_blank"
      aria-label={name}
    >
      {icon}
    </a>
  )
}
